(function () {
  function bindTabs(root) {
    if (!root || root.getAttribute('data-pdp-tabs-bound') === '1') return;
    root.setAttribute('data-pdp-tabs-bound', '1');
    var tabs = root.querySelectorAll('[data-pdp-tab]');
    var panels = root.querySelectorAll('[data-pdp-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-pdp-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-pdp-panel') !== id;
        });
      });
    });
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-pdp-tabs]').forEach(bindTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  function bindDesc(root) {
    if (!root || root.getAttribute('data-pdp-desc-bound') === '1') return;
    root.setAttribute('data-pdp-desc-bound', '1');
    var btn = root.querySelector('[data-pdp-desc-toggle]');
    var body = root.querySelector('.pdp-desc__body');
    if (!btn || !body) return;
    btn.addEventListener('click', function () {
      root.classList.toggle('is-collapsed');
      btn.textContent = root.classList.contains('is-collapsed') ? 'Mostra di più' : 'Mostra di meno';
    });
  }

  function scanDesc(scope) {
    (scope || document).querySelectorAll('[data-pdp-desc]').forEach(bindDesc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanDesc(document);
    });
  } else {
    scanDesc(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanDesc(event.target);
  });
})();
